import type { EscriptProps, OptimisticPendingTransfer } from 'src/app/types';

import { VERSION } from '../../consts';

import { NoRx } from './NoRx';
import { RxFound } from './RxFound';
import { RxNotFound } from './RxNotFound';
import { RxProcessing } from './RxProcessing';
import { RxTransfer } from './RxTransfer';

interface ConfirmationVersionProps {
  escriptCounts: EscriptProps[];
  isDoctorTransfer: boolean;
  medications: OptimisticPendingTransfer[];
  onChatClick: () => void;
  onContinue: () => void;
  onContinueToRxPage: () => void;
  onSkipForNowClick: () => void;
  version: string;
}

export const ConfirmationVersion = ({
  escriptCounts,
  isDoctorTransfer,
  medications = [],
  onChatClick,
  onContinue,
  onContinueToRxPage,
  onSkipForNowClick,
  version,
}: ConfirmationVersionProps) => {
  // transfer prescription or enter new prescription
  if (version === VERSION.TRANSFER) {
    return (
      <RxTransfer
        escriptCounts={escriptCounts}
        isDoctorTransfer={isDoctorTransfer}
        medications={medications}
        onChatClick={onChatClick}
        onContinue={onContinue}
      />
    );
  }

  // escript: rx match and is ready
  if (version === VERSION.FOUND) {
    return <RxFound escriptCounts={escriptCounts} medications={medications} onContinue={onContinue} />;
  }

  // escript: rx match but still processing
  if (version === VERSION.PROCESSING) {
    return <RxProcessing escriptCounts={escriptCounts} medications={medications} onContinue={onContinue} />;
  }

  // create account with no medications
  if (version === VERSION.NO_RX) {
    return <NoRx onContinueToRxPage={onContinueToRxPage} onSkipForNowClick={onSkipForNowClick} />;
  }

  // escript: no rx match
  // or: flow and rx status do not match any of the above combos
  return <RxNotFound onChatClick={onChatClick} onContinue={onContinue} />;
};
